/**
 * LanguagesContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled languages container.
 */
const LanguagesContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;
  left: ${-860 * Screen.widthRatio}px;
`;

export default withOpacity(LanguagesContainer);
